export enum CALL_SESSION_TYPE {
  ERROR = 'error',
  WARNING = 'warning',
  NORMAL = 'normal',
  INFO = 'info'
}
